import mapToRange from '@cotyorg/ccx-utils/js/helpers/mapToRange';
import R from 'ramda';

export const getValueFromKey = ({
  key,
  currentValue = 0,
  min = 0,
  max = 1,
}) => (
  R.cond([
    [R.either(R.equals('ArrowDown'), R.equals('ArrowLeft')), R.always(Math.max(min, currentValue - 1))],
    [R.either(R.equals('ArrowUp'), R.equals('ArrowRight')), R.always(Math.min(max, currentValue + 1))],
    [R.equals('PageDown'), R.always(Math.max(min, currentValue - 10))],
    [R.equals('PageUp'), R.always(Math.min(max, currentValue + 10))],
    [R.equals('Home'), R.always(min)],
    [R.equals('End'), R.always(max)],
    [R.T, R.always(currentValue)],
  ])(key)
);

export const mapPositionToValue = ({
  min,
  max,
  position,
  trackLeft,
  trackWidth,
}) => (
  Math.round(mapToRange({
    value: position - trackLeft,
    inMin: 0,
    inMax: trackWidth,
    outMin: min,
    outMax: max,
  }))
);

export const mapValueToPosition = ({
  value,
  min,
  max,
  trackWidth,
  trackLeft,
}) => (
  mapToRange({
    value,
    inMin: min,
    inMax: max,
    outMin: trackLeft,
    outMax: trackWidth + trackLeft,
  })
);

export const mapPositionToPercentage = ({
  position,
  trackLeft,
  trackWidth,
}) => (
  mapToRange({
    value: position - trackLeft,
    inMin: 0,
    inMax: trackWidth,
    outMin: 0,
    outMax: 100,
  })
);

export const mapValueToPercentage = ({
  value,
  min,
  max,
}) => (
  mapToRange({
    value,
    inMin: min,
    inMax: max,
    outMin: 0,
    outMax: 100,
  })
);

export const getHandlePercentage = ({
  smoothSlide,
  isDragging,
  currentPercentage,
  currentValue,
  min,
  max,
}) => (
  smoothSlide && isDragging ? (
    currentPercentage
  ) : (
    mapValueToPercentage({
      value: currentValue,
      min,
      max,
    })
  )
);
